<template>
    <SettingsOrgLevels :client="client" @updated="onSetupComplete"/>
</template>
<script>
    import SettingsOrgLevels from '@/pages/client/Settings/OrgLevels'

    export default {
        props: ['client', 'setupStatus'],
        components: {SettingsOrgLevels},
        data() {
            return {}
        },
        methods: {
            onSetupComplete() {
                this.$store.dispatch('START_LOADING')
                this.$api.post(`/clients/${this.client.id}/setup-status`, {step: 'org_levels'}).then(resp => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$emit('refreshClient')
                }).catch((errors) => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showError(errors.__all__)
                })
            },
        },
    }
</script>
